export const environment = {
  production: true,
  environment: 'staging',
  appName: 'Gozem Accounts',
  // The deployed staging environment. `accounts-staging.gozem.co` was here and does not exist in
  // DNS, so every call from the deployed SPA failed to resolve. As on test, the API is served from
  // the SAME ORIGIN as this app under a path prefix, which also satisfies the `default-src 'self'`
  // CSP in conf/nginx.conf -- a cross-origin API host would be blocked by it even once DNS existed.
  accountsApiUrl: 'https://stage-account.gozem.co/api_account',
  /**
   * Redirect targets this environment may hand an authorization code to.
   *
   * The service validates independently and is the authority. This list exists so a foreign
   * redirect_uri fails on OUR origin with our own error page, rather than after a round trip — the
   * rule GPGT-41350 states as "validate before rendering any UI".
   *
   * A leading dot opts a host into its subdomains ('.staging.gozem.co' matches 'app.staging…').
   * Exact hostname otherwise: a prefix test would accept 'gozem.co.attacker.tld'.
   */
  allowedRedirectOrigins: [
    // Where the partner hub actually is on staging. It is NOT a subdomain of staging.gozem.co, so
    // the entry below never matched it and the partner hub's redirect was refused.
    'https://staging-webapp.gozem.co',
    'https://.staging.gozem.co',
  ] as const,
};
